
/*
    Display for all current lane changes as a list,
    with a small filter on top for selecting the location to view,
    and also a form for adding new lane changes

    handle the logic for editing existing lane changes when a form within the 
    individual data components are submitted
*/

import React, { useContext } from "react";

import MainContext from "../MainContext";
import DataContext from "../DataContext";

import SubNav from "../Components/SubNav";
import SingleOpenList from "../Components/SingleOpenList";
import LocationDropDown from "../Components/LocationDropDown";
import VerticalLayout from "../Components/VerticalLayout";

import LaneChangeData from "../DataDisplay/LaneChangeData";
import LaneChangeForm from "../Forms/LaneChangeForm";
import LaneChangeFilter from "../Filters/LaneChangeFilter";

import * as LaneRequests from "../Requests/LaneRequests";

import { addElement, replaceElement } from "../Scripts/Utilities";

//
//
function createDateParameter(date, time){
    // put the date parameter into the correct format
    // DD-MON-YY HH:MI AM

    console.log("LANE UPDATE DATETIME", date, time, typeof date);

    const timeSplit = time.split(":");

    let timeToUse = time;

    console.log("KEY DATE TIME", date, time);

    if(timeSplit[0] > 12){
        const newHour = (timeSplit[0] - 12);
        timeToUse = newHour + ":" + timeSplit[1];
        if(newHour < 10){
            timeToUse = "0" + timeToUse;
        }
    }
    else if(timeSplit[0] == 0){
        timeToUse = "12:" + timeSplit[1];
    }

    if(time.trim().indexOf(" ") < 0){
        timeToUse += (timeSplit[0] > 12) ? " PM" : " AM";
    }

    // // just append
    // if(typeof date === "string"){
    //     const dd = new Date(date);
    //     console.log("INNER DATE STRING", date, dd);
    //     return date + " " + timeToUse;
    // }

    const d = (typeof date === "object") ? date : new Date(date);

    console.log("UPDATE LANE DATE OBJECT", date, d, time, timeSplit);

    // d.setHours(timeSplit[0]);
    // d.setMinutes(timeSplit[1]);

    console.log("DATES", date, d, d.getDate(), d.getMonth() + 1);

    const hour = d.getHours();
    let hourToUse = hour;
    if(hour > 12) {
        hourToUse = hour - 12;
    }
    else if(hour === 0){
        hourToUse = "12";
    }

    console.log("DATES MIDPOINT", hourToUse, hour);

    if(hourToUse < 10){
        hourToUse = "0" + hourToUse;
    }

    let dayToUse = d.getDate();
    if(dayToUse < 10){
        dayToUse = "0" + dayToUse;
    }

    let monthToUse = d.getMonth() + 1;
    if(monthToUse < 10){
        monthToUse = "0" + monthToUse;
    }

    let minuteToUse = d.getMinutes();
    if(minuteToUse < 10){
        minuteToUse = "0" + minuteToUse;
    }

    let yearToUse = d.getFullYear() - 2000;

    // let ret = `${dayToUse}-${monthToUse}-${yearToUse} ${hourToUse}:${minuteToUse} ${(d >= 12) ? 'PM' : 'AM'}`;
    let ret = `${dayToUse}-${monthToUse}-${yearToUse} ${timeToUse}`;

    console.log("THE DATETIME STRING CREATED", ret);

    return ret;
}

//
// construction for allowing changes to the DataContext to properly trigger a data reload
//
const LaneChangePageContainer = (props) => {
    const context = useContext(DataContext);

    return (
        <LaneChangePage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default LaneChangePageContainer;

class LaneChangePage extends React.Component {

    static contextType = MainContext;

    state = {
        location: "",
        laneChanges: [],
        addLaneFormOpen: false,
        locationChanging: false,
        closeAll: false,
        message: ""
    }

    onLocationChange = (evt) => {
        this.setLocation(evt.target.value)
    }

    setLocation = (location) => {
        this.setState({location, locationChanging: true}, ()=> {
            this.getData();
        });
    }

    getData = () => {
        const request = () => LaneRequests.getLaneChanges(this.state.location);

        const isTest = false;

        if(isTest){
            const mockData = [
                {
                    location_id: "PABT",
                    route: 134,
                    current_gate: 111,
                    new_gate: 112,
                    start_date: "DD-MON-YY HH:MI AM",
                    end_date: "DD-MON-YY HH:MI AM",
                    last_modified: "DD-MON-YY HH:MI AM",
                    username: "VISSRXN"
                },
                {
                    location_id: "PABT",
                    route: 134,
                    current_gate: 111,
                    new_gate: 112,
                    start_date: "DD-MON-YY HH:MI AM",
                    end_date: "DD-MON-YY HH:MI AM",
                    last_modified: "DD-MON-YY HH:MI AM",
                    username: "VISSRXN"
                }
            ];

            this.setState({laneChanges: mockData, locationChanging: false, message: ""});

            return;
        }

        const then = ({data}) => {
            console.log("LANE CHANGE DATA", data);
            if(data && data.length){

                const dataToUse = [...data];
                dataToUse.reverse();

                // need to filter by the current location
                console.log("CURRENT LOCATION", this.state.location);
                if(this.state.location){
                    const copy = [];
                    dataToUse.forEach(d => {
                        if(d.location_id === this.state.location){
                            copy.push(d);
                        }
                    });
                    console.log("COPY", copy);

                    if(copy.length){
                        this.setState({laneChanges: copy, locationChanging: false, message: ""});
                    }
                    else{
                        this.setState({laneChanges: [], locationChanging: false, message: "No records for this location"});
                    }

                }
                else{
                    this.setState({laneChanges: data, locationChanging: false, message: ""});
                }
            }
            else{
                this.setState({laneChanges: [], locationChanging: false, message: "No records for this location"});
            }
        };

        this.context.runProcessing(request, then, "getLaneChanges");
    }

    //
    //
    componentDidMount(){
        if(this.context.user.currentLocation.location_id) {
            this.setLocation(this.context.user.currentLocation.location_id);
        }
    }

    //
    // either the message form is opened and we need to close the filter,
    // or we need to reload
    //
    componentDidUpdate() {
        if(this.context.filterOpen && this.state.addLaneFormOpen){
            this.setState({addLaneFormOpen: false});
        }
        else if(this.props.dataReload){
            this.props.setReload(false, () => {                
                this.getData();
            });
        }
    }

    // interaction with the lane change form
    openLaneForm = () => {
        this.setState({addLaneFormOpen: true});
    }

    closeLaneForm = (callback) => {
        this.setState({addLaneFormOpen: false, closeAll: true}, () => {
            this.setState({closeAll: false});
            if(callback && typeof callback === "function"){
                callback();
            }
        });
    }

    addLaneChange = (change) => {

        const params = {
            location_id: this.state.location,
            route: change.routeSelected,
            current_gate: change.originalLane,
            new_gate: change.newLane,
            start_date: createDateParameter(change.startDate, change.startTime),
            end_date: createDateParameter(change.endDate, change.endTime)
        };

        console.log("ADD LANE CHANGE", change, params);

        const request = () => LaneRequests.addLaneChange(params);
        const then = ({data}) => {
            // ...
            if(data){
                this.getData();

                this.setState({
                    // laneChanges: addElement(this.state.laneChanges, change),
                    addLaneFormOpen: false
                });

                this.closeLaneForm(() => {
                    this.context.sendNotification(false, "Lane Change Added");
                })
            }
            else{
                this.context.sendNotification(true, "Add lane change failed, please try again");
            }
        }

        this.context.runProcessing(request, then, "addLaneChange");
    }

    // pass down to the child data elements
    updateLaneChange = (change, index) => {
        
        console.log("LANE UPDATE LOCATION", change, this.state.location, this.state.laneChanges, index);
        
        const initial = this.state.laneChanges[index];

        const params = {
            id: initial.id,
            location_id: initial.location_id,
            route: change.routeSelected,
            current_gate: change.originalLane,
            new_gate: change.newLane,
            start_date: createDateParameter(change.startDate, change.startTime),
            end_date: createDateParameter(change.endDate, change.endTime)
        };

        console.log("UPDATE LANE CHANGE", change, index, params);

        const request = () => LaneRequests.updateLaneChange(params);
        const then = ({data}) => {
            // ...
            if(data){
                this.getData();

                this.setState({
                    addLaneFormOpen: false
                });

                this.closeLaneForm(() => {
                    this.context.sendNotification(false, "Lane Change Updated");
                });
            }
            else{
                this.context.sendNotification(true, "Update lane change failed, please try again");
            }
        }

        this.context.runProcessing(request, then, "updateLaneChange");
    }

    deleteHandler = () => {
        // just get the data again
        this.getData();
    }

    render() {
        return (
            <VerticalLayout firstHeight={this.context.filterOpen || this.state.addMessageFormOpen ? 0 : 8}>
                {
                    !this.context.filterOpen
                    ? <SubNav>
                        <div className="form-element-horizontal">
                            <label>Location</label>
                            <LocationDropDown setFocus={true} selected={this.state.location} updateValue={this.onLocationChange} />
                        </div>
                        {
                            this.state.location && !this.state.addLaneFormOpen 
                            ? <div className="option  " onClick={this.openLaneForm}>Add Lane</div>
                            : null
                        }
                    </SubNav>
                    : <></>
                }
                <div className="content">
                    {
                        this.state.location && this.state.addLaneFormOpen && !this.context.filterOpen
                        ? <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            marginBottom: "8px"          
                        }}>
                            <LaneChangeForm location={this.state.location} onSubmit={this.addLaneChange} />
                            <div className="option option-low-vertical"
                            style={{
                                alignSelf:"flex-end",
                                justifySelf:"flex-end",
                                margin: "10px 12px 6px 6px"
                            }}
                                onClick={() => this.setState({"addLaneFormOpen": false})}
                            >
                                Close
                            </div>
                        </div>
                        : null
                    }
                    {
                        // show the filter or not
                        this.context.hasFilter
                        && this.context.filterOpen
                        && !this.state.addLaneFormOpen
                            ? <LaneChangeFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} mode={this.props.mode} />
                            : null
                    }
                    {
                        this.state.message !== ""
                        ? <div className="message">
                            {this.state.message}
                        </div>
                        : null
                    }
                    <SingleOpenList 
                        data={this.state.laneChanges} 
                        component={LaneChangeData} 
                        forceClose={this.state.closeAll || this.state.addLaneFormOpen || this.state.locationChanging}
                        prependCall={(mainFunc) => this.closeLaneForm(mainFunc)}
                        props={{
                            onSubmit: this.updateLaneChange,
                            addLaneChange: this.addLaneChange,
                            deleteHandler: this.deleteHandler,
                            location: this.state.location
                        }} 
                    />
                </div>
            </VerticalLayout>
        )
    }
}
